import React, { useState } from "react";
import ImageUpload from "./ImageUpload";
import ImageControls from "./ImageControls";
import { apiService } from "../services/apiService";

const ImageTab = ({ addNotification }) => {
  const [confidence, setConfidence] = useState(0.7);
  const [analyzing, setAnalyzing] = useState(false);
  const [result, setResult] = useState(null);

  const handleAnalyzeImage = async (file) => {
    setAnalyzing(true);
    setResult(null);

    try {
      addNotification("Analyzing image...", "info");
      const analysisResult = await apiService.analyzeImage(file, confidence);

      if (analysisResult.success) {
        setResult(analysisResult);
        addNotification(
          `Analysis complete! Found ${analysisResult.detection_count} detection(s)`,
          "success"
        );
      } else {
        addNotification("Failed to analyze image", "error");
      }
    } catch (error) {
      addNotification(`Error analyzing image: ${error.message}`, "error");
    } finally {
      setAnalyzing(false);
    }
  };

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "30px",
        marginBottom: "30px",
      }}
    >
      <ImageControls confidence={confidence} setConfidence={setConfidence} />

      <ImageUpload
        confidence={confidence}
        onAnalyze={handleAnalyzeImage}
        analyzing={analyzing}
        result={result}
      />
    </div>
  );
};

export default ImageTab;
